module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0063.jpg?v=89aeb93a";